cafm.filters = {
    setupFilterPanel: function (o) {
        /// <summary>Setup function for filter panels</summary>
        /// <param name="o" type="Object">The filter options object</param>
        
        cafm.handlers.set('cafm.filters.treeItemSelected', function (e) {
            cafm.filters.treeItemSelected(e, o);
        });

        var dsEl = cafm.filters.getDsElement(o), 
            pnl = $('#{0}'.format(o.panelId)),
            criteria = cafm.cache.getObject(o.defaultCriteria);

        pnl.data('options', o);

        cafm.filters.contextDefaultCriteria = $.extend(o.defaultCriteria, cafm.filters.baseCriteria(pnl));

        // if there's no cached criteria
        if (!criteria) {

            criteria = o.criteria;
        }

        if (criteria) {

            criteria = $.extend(criteria, cafm.filters.baseCriteria(pnl));
        }
        else {

            console.log('Criteria must be set on the grid or list control prior to setting up the associated filter panel.');
            return;
        }

        if (o.onPreBind) {

            cafm.util.callFunction(o.onPreBind, criteria, pnl, true);
        }

        dsEl.setCriteria(criteria);

        var viewModel = criteria ? criteria : cafm.filters.contextDefaultCriteria;
        cafm.filters.contextDefaultCriteria.SuppressVisibleColumnsChanged = true;

        if (!cafm.util.hasItem(criteria.VisibleColumns)) {

            criteria.VisibleColumns = o.defaultCriteria.VisibleColumns;
        }

        pnl.bindViewModel({
            viewModel: viewModel
        });
        viewModel = pnl.getViewModel();
        //viewModel.set('HasChanged', false);

        if (!viewModel) return;

        setTimeout(function () {
            cafm.filters.populateFilterTree(pnl);
        }, 1000);

        // bind criteria changed event
        viewModel.bind('change', cafm.filters.criteriaChanged);

        // if we are persisting grid state attach column reorder and data source change handlers 
        if (viewModel.get('PersistGridState')) {

            dsEl.data('columnsReordered', cafm.grids.columnsReordered);
            dsEl.data('dataSourceChanged', cafm.grids.ensureGridState);
            if (viewModel.get('IsNewSearch') || viewModel.get('IsCustomSearch')) {

                $('.resetBtn', pnl).hide();
            }
            if (viewModel.get('IsNewSearch')) {

                cafm.filters.newSearch(pnl);
            }
        }

        pnl.find('.cfTextInput,.cfLookupInput').enterPressed(e => {
            $(e.currentTarget).blur();
            setTimeout(() => { cafm.filters.filterActions.search(pnl); }, 125);
        });

        if (o.filteringMode == cafm.enums.FilteringMode.ClientSide && o.renderingMode == cafm.enums.FilterSetRenderingMode.SingleTextBox) {

            cafm.filters.client.setupSingleTextBoxFilter(pnl, dsEl);
        }

        if (cafm.filters.openOnNextLoad) {

            cafm.filters.showPanel();
            delete cafm.filters.openOnNextLoad;
        }

        if (cafm.nav.router)
            cafm.nav.router.onRouteChanged(function () {
                cafm.filters.hideFilterPanel(pnl);
                cafm.util.kendoDestroy(pnl);
                pnl.remove();
            });
    },
    showFilterPanel: function (o) {
        /// <summary>Shows the filter panel</summary>
        /// <param name="o" type="Object">The filter options object</param>

        var pnl = $('#{0}'.format(o.panelId));

        // check if filters have already been 'placed' or not
        if (!pnl.data('placed')) {

            if (!isMobile) {

                pnl.css({ top: cafm.panel.getHeaderHeight() }).appendTo(body);
            }

            // set state of panel to 'placed', this ensures one time execution
            pnl.prepareForm().data('placed', true).data('options', o);

            // fire on filters ready event
            cafm.filters.fireOnFiltersReady();
        } else  {
            if (isMobile) {
                pnl.prepareForm();//This will setup Date text boxes on form by calling  cafm.util.ensureDate on each. See CFM-2104/2785
            }
        } 

        var btns = $('.filterButtons', pnl);
        if (!pnl.data('expanded')) {

            var onExpand = function () {

                pnl.data('expanded', true);
                btns.show();
            }

            if (isMobile) {

                pnl.show();
                //scrollBase();
                onExpand();
            }
            else {

                pnl.slideUp();
                pnl.slideDown(onExpand);
            }
        }
        else {
            cafm.filters.hideFilterPanel(pnl);
        }
    },
    hideFilterPanel: function (pnl) {
        /// <summary>Hides the filter panel</summary>
        /// <param name="o" type="Object">The filter options object</param>

        if (!pnl) {
            pnl = cafm.filters.getPanel();
        }

        if (isMobile || isTouch && cafm.browsers.isSafari()) {

            pnl.hide();
            pnl.data('expanded', false);
        }
        else {

            pnl.slideUp(function (e) {

                pnl.data('expanded', false);
            });
        }

        nav.findNavTreeElements('.tvActive:not(.topTvItem)').removeClass('tvActive');
    },
    showPanel: function() {

        var p = cafm.filters.getPanel();

        if (p) {
            var o = p.data('options');
            cafm.filters.showFilterPanel(o);
        }
    },
    hidePanel: function () {

        var p = cafm.filters.getPanel();

        if (p) {
            cafm.filters.hideFilterPanel(p);
        }
    },
    getPanel: function () {

        return $('#{0}'.format(cafm.res.consts.ElementId_FilterSet));
    },
    getViewModel: function () {

        return cafm.filters.getPanel().getViewModel();
    },
    setViewModel: function (viewModel) {

        return cafm.filters.getPanel().setViewModel(viewModel);
    },
    getDsElement: function(o){

        let dsElId = o.dsElementId,
            dsElCl = isMobile && o.renderingMode != cafm.enums.FilterSetRenderingMode.SingleTextBox ? 'cLv' : 'cGrd',
            dsSel = '#{0} .{1}'.format(dsElId, dsElCl);
        return $(dsSel);
    },
    filterActions: {
        search: function (pnl, saveNewSearch) {
            /// <summary>Handler for search button click</summary>
            /// <param name="pnl" type="JQuery">The filter panel element</param>

            var criteria = pnl.getViewModel();

            if (!saveNewSearch && !criteria.get('IsNewSearch')) {

                // set this flag so the element is aware the search button has been clicked
                cafm.filters.getDsElement(pnl.data('options')).data('Searching', true);
            }
            
            // perform the search
            cafm.filters.search(pnl);
        },
        reset: function (e, pnl) {
            /// <summary>Handler for reset button click</summary>
            /// <param name="e" type="Object">The DOM event</param>
            /// <param name="pnl" type="JQuery">The filter panel element</param>

            var o = pnl.data('options');
            var dse = cafm.filters.getDsElement(o);
            dse.data('ResettingSearch', true);

            var criteria = pnl.getViewModel();
            var defaultCriteria = cafm.filters.contextDefaultCriteria; 

            criteria.set('SuppressVisibleColumnsChanged', true);

            if (!isMobile) {

                let ds = dse.getDataSource();
                if (cafm.util.hasItem(ds.sort()) && cafm.util.hasItem(defaultCriteria.SortOptions)) {

                    ds._sort = [{
                        field: defaultCriteria.SortOptions[0].Field,
                        dir: cafm.ds.toSortDirString(defaultCriteria.SortOptions[0].Direction)
                    }];
                }
                else {

                    ds._sort = [];
                }
            }

            // take a copy of the visible columns now so they can be reapplied as reset is just for filters and paging
            let vc = cafm.util.transformArray(criteria.VisibleColumns, function (vc) {
                return isStr(vc) ? vc : vc.value;
            });

            // now populate the criteria with default properties
            criteria.set(defaultCriteria);
            // reapply visible columns
            criteria.set('VisibleColumns', vc);

            // call on prebind
            if (o.onPreBind) {
                cafm.util.callFunction(o.onPreBind, criteria, pnl, true);
            }

            // set has changed to trigger save
            criteria.HasChanged = true;

            pnl.setViewModel(criteria);
            pnl.find('.k-multiselect').setMultiSelectText();
            
            if (criteria.SuppressVisibleColumnsChanged) {

                criteria.set('SuppressVisibleColumnsChanged', false);
            }

            cafm.filters.search(pnl, 0);

            cafm.filters.fireOnCriteriaReset(criteria);
        },
        cancel: function (e, pnl) {
            /// <summary>Handler for cancel button click</summary>
            /// <param name="e" type="Object">The DOM event</param>
            /// <param name="pnl" type="JQuery">The filter panel element</param>

            $(e.target).blur();
            cafm.filters.hideFilterPanel(pnl);

            var criteria = pnl.getViewModel();
            if (criteria.get('IsNewSearch')) {

                cafm.nav.router.navigateDefault();
            }
        },
        save: function () {
            
            cafm.filters.openSaveWindow(cafm.filters.getViewModel());
        }
    },
    search: function (pnl, tout) {
        /// <summary>Search function - uses filters elected</summary>
        /// <param name="pnl" type="JQuery">The filter panel element</param>
        /// <param name="tout" type="JQuery">The filter panel element</param>
        /// <param name="pnl" type="JQuery">The filter panel element</param>

        cafm.hi.hideHierarchySearchButton();

        setTimeout(function () {

            let options = pnl.data('options');
            let preSearch = cafm.util.getReference(options.onPreSearch);
            let criteria;
            let updatedCriteria;
            let dse = cafm.filters.getDsElement(options);

            if (isFunc(preSearch)) {

                updatedCriteria = preSearch(pnl);
            }

            if (updatedCriteria) {

                criteria = updatedCriteria;
            }
            else {

                criteria = pnl.getViewModel();
            }

            // ensure visible columns are just string field names
            criteria.VisibleColumns = cafm.util.transformArray(criteria.VisibleColumns, function (vc) {

                return isStr(vc) ? vc : vc.value;
            });

            criteria = criteria.toJSON();
            dse.setCriteria(criteria);

            // check for client side filtering, if so process filters client side and exit method
            if (options.filteringMode == cafm.enums.FilteringMode.ClientSide) {

                cafm.filters.client.applyFilters(pnl, dse);
                return false;
            }

            let ds = dse.getDataSource();
            ds._requestInProgress = false;

            dse.data('onDataSourceRead', function () {

                criteria = pnl.getViewModel();

                if (criteria.IsNewSearch && criteria.SaveCustomSearch) {

                    switch (cafm.getCurrentModule()) {

                        case cafm.enums.CAFMModuleEnum.Helpdesk:

                            cafm.nav.router.navigate(cafm.enums.Navigatable.HelpdeskSavedSearch, {
                                value: criteria.SearchKey
                            });
                            break;

                        case cafm.enums.CAFMModuleEnum.Property:

                            cafm.nav.router.navigate(cafm.enums.Navigatable.PropertySavedSearch, {
                                value: criteria.SearchKey
                            });
                            break;
                    }

                    if (criteria.SaveCustomSearch)
                        SavedSearchList.refresh();

                    return;
                }
                else {

                    cafm.filters.populateFilterTree(pnl);

                    if (criteria.get('SearchDescriptionChanged')) {

                        var sel = '.topTvItem[data-value="{0}"] .k-in:first'.format(criteria.SearchKey);
                        var savedSearchTreeItem = nav.findNavTreeElements(sel);
                        savedSearchTreeItem.text(criteria.SearchDescription);
                    }
                }

                if (criteria.get('VisibleColumnsChanged')) {

                    cafm.filters.visibleColumnsChanged(pnl, dse, options, criteria);
                }

                if (criteria.SaveCustomSearch)
                    SavedSearchList.refresh();

                if (criteria.IsCustomSearch) {
                    
                    criteria.SaveCustomSearch = false;
                }

                // ensure this is removed after each search
                dse.removeData('ResettingSearch');

                // ensure this is removed after each search
                dse.removeData('Searching');
            });

            if (isMobile) {

                cafm.filters.hideFilterPanel(pnl);
            }

            // if the page is not one or this is a new search
            if (ds.page() != 1) {

                // reset page to 1
                ds.page(1);

                // if not server paging we must call ds read
                if (!ds.options.serverPaging) {

                    ds.read();
                }
            }
            else {

                // otherwise just call ds read
                ds.read();
            }

            if (!isMobile) {

                cafm.filters.hideFilterPanel(pnl);
            }

        }, isNum(tout) ? tout : 500); // wait for .5 seconds to allow the view model to update before searching
    },
    contextDefaultCriteria: null,
    baseCriteria: function (pnl) {
        /// <summary>Get the base criteria for all filters</summary>
        /// <param name="pnl" type="JQuery">The filter panel element</param>
        /// <returns type="Object">The base criteria</returns>

        return {
            search: function (e) {
                cafm.filters.filterActions.search(pnl);
            },
            reset: function (e) {
                cafm.filters.filterActions.reset(e, pnl);
            },
            cancel: function (e) {
                cafm.filters.filterActions.cancel(e, pnl);
            },
            save: function (e) {
                cafm.filters.filterActions.save(e, pnl);
            }
        }
    },
    treeItemSelected: function (key, pnl) {
        /// <summary>Handler for filter category tree item click</summary>
        /// <param name="key" type="String">The filter category key</param>
        /// <param name="pnl" type="JQuery">The filter panel element</param>

        var options = pnl.data('options');
        var tv = nav.getKendoFilterTree();
        var item = nav.findFilterTreeElements('.tvItem[data-key="{0}"]'.format(key));
        if (pnl && key != 'Actions') {
            if (!pnl.data('expanded')) {
                cafm.filters.showFilterPanel(pnl.data('options'));
            }
            $('.filtersPlc .k-tabstrip-items .k-item[data-key="{0}"]'.format(key)).click();
        }

        tv.select(item);
        tv.expand(item);
    },
    treeFilterSelected: function (key, pnl, controlType) {
        /// <summary>Handler for filter tree item click</summary>
        /// <param name="key" type="String">The filter key</param>
        /// <param name="pnl" type="JQuery">The filter panel element</param>
        /// <param name="controlType" type="String">The control type key</param>

        var item = nav.findFilterTreeElements('.tvItem[data-key="{0}"]'.format(key));
        cafm.filters.treeItemSelected(item.parents('.tvItem:first').data('key'), pnl);
    },
    populateFilterTree: function (pnl) {

        var options = pnl.data('options');

        if (!pnl.data('options')) {

            return;
        }

        let criteria = pnl.getViewModel();
        let tvEl = nav.getFilterTree();
        let tv = nav.getKendoFilterTree();
        let filterCats = $('.tvItem[data-itemtype="' + cafm.enums.TreeViewItemType.FilterCategory + '"]', tvEl);
        let filterItems = $('.tvItem[data-itemtype="' + cafm.enums.TreeViewItemType.Filter + '"]', tvEl);

        if (tv) {

            tv.expand(filterCats);

            let childNodes = $('.tvFilterVal', tvEl);

            childNodes.each(function (i, node) {

                tv.remove(node);
            });

            filterItems.each(function (i, f) {

                let filterItem = $(f);
                let fieldName = filterItem.data('key');
                let fieldValue = criteria.get(fieldName);

                if (fieldValue && fieldValue != cafm.guid.empty && (!isDefined(fieldValue.length) || fieldValue.length > 0)) {

                    fieldName = fieldName.replace(/[.]/, '_');

                    let controlType = filterItem.data('controltype'),
                        fieldCont = $('#{0}'.format(fieldName + 'Filter'), pnl);
                    
                    if (!fieldCont.length) {

                        fieldCont = $('#{0}'.format(fieldName)).closest('.cfField');
                    }

                    // attempt to get the filter value description
                    try {

                        valDesc = cafm.filters.getFilterValueDescription(fieldCont, controlType, fieldValue, criteria);
                    }
                    catch (err) {

                        // log error to consile
                        console.error('Filter value description not generated for field "{0}". Error message: {1}'.format(fieldName, err.message));
                    }

                    let isArr = isArray(valDesc);
                    if (isArr) {

                        $.each(valDesc, function (i, v) {

                            let newItem = tv.append({
                                text: v,
                                spriteCssClass: 'remove-filter-icon'
                            }, filterItem);
                            newItem.addClass('tvFilterVal').attr('data-itemtype', 4).attr('title', v).data('value', fieldValue[i]);
                        });
                    }
                    else if (valDesc) {

                        let newItem = tv.append({
                            text: valDesc,
                            spriteCssClass: 'remove-filter-icon'
                        }, filterItem);
                        newItem.addClass('tvFilterVal').attr('data-itemtype', 4).attr('title', valDesc).data('value', fieldValue);
                    }
                    
                    if ((!isArr && valDesc) || (isArr && cafm.util.hasItem(valDesc))) {
                        filterItem.show();
                    }
                    else {
                        filterItem.hide();
                    }
                }
                else {
                    filterItem.hide();
                }
            });

            $('.tvFilterVal').click(function (e) {
                let item = $(e.target).parents('.tvFilterVal:first');
                cafm.filters.removeFilter(item, tv, pnl);
                return false;
            });
        }
    },
    getFilterValueDescription(control, controlType, value, criteria) {

        let items;
        let item;
        switch (cafm.enums.ControlType[controlType]) {
            case cafm.enums.ControlType.DatePicker:

                return kendo.toString(cafm.util.ensureDate(value), 'd');

            case cafm.enums.ControlType.DateFromWithUTCPicker:
            case cafm.enums.ControlType.DateToWithUTCPicker:
                {

                    if (!cafm.util.dateStringIsMin(value)) {
                        var dtLocal = cafm.web.funcs.fromUTCToSessionDateOnly(value);
                        return kendo.toString(cafm.util.ensureDate(dtLocal), 'd');
                    } else {
                        return null;
                    }
                }
            case cafm.enums.ControlType.Dropdown:
                {
                    items = $('select', control).data('items');
                    item = cafm.util.find(items, function (item) {
                        if (isObj(value)) {
                            return item.value == value.value;
                        }
                        else {
                            return item.value == value;
                        }
                    });
                    return item ? item.text : '';
                }
            case cafm.enums.ControlType.MultiDropdown:
                {
                    items = $('select', control).data('items');

                    if (!value.length) {
                        return '';
                    }
                    else if (value.length == 1) {
                        item = cafm.util.find(items, function (item) {
                            let v = value[0];
                            v = isObj(v) ? v.value : v;
                            return item.value == v;
                        });
                        return item ? item.text : '';
                    }
                    else {
                        let txtItems = [];
                        $.each(value, function (i, v) {

                            let item = cafm.util.find(items, function (item) {
                                if (isObj(v)) {
                                    return item.value == v.value;
                                }
                                else {
                                    return item.value == v;
                                }
                            });
                            if (item) {
                                txtItems.push(item.text);
                            }
                        });
                        return txtItems;
                    }
                }

            case cafm.enums.ControlType.LocalitySelector:
            case cafm.enums.ControlType.Lookup:
            case cafm.enums.ControlType.TradeFilter:
            case cafm.enums.ControlType.TradePersonFilter:
            case cafm.enums.ControlType.ReasonCodeFilter:
                {
                    if (control.data('showlist')) {

                        let dataItems = control.find('.simpleList').data('items');
                        
                        if (cafm.util.hasItem(dataItems)) {

                            items = [];

                            if (!isArray(dataItems)) {

                                dataItems = dataItems.toJSON();
                            }

                            $.each(dataItems, function (i, di) {

                                items.push(di.text);
                            });
                        }

                        return items;
                    }
                    else {

                        let tbox = $('.cfLookupInput', control);
                        let val;

                        if (tbox.length) {
                            let ph = tbox.attr('placeholder');
                            val = tbox.val();
                            return ph == val ? '' : val;
                        }
                        else {

                            let select = $('select', control);
                            items = select.data('items');

                            if (items) {
                                item = cafm.util.find(items, function (item) {
                                    if (isObj(value)) {
                                        return item.value == value.value;
                                    }
                                    else {
                                        return item.value == value;
                                    }
                                });
                                return item ? item.text : '';
                            }
                            else {
                                let fieldName = select.getDataBoundFieldName();
                                if(fieldName.endsWith('ID'))
                                    return criteria.get(fieldName.substr(0, fieldName.length - 2) + 'Description');                                
                            }
                        }
                    }
                }

            case cafm.enums.ControlType.TriStateCheckbox:
                {
                    let v = parseInt($('.cfControl', control).val());

                    switch (v) {
                        case cafm.enums.DefaultableBooleanData.True:
                            return cafm.res.str.TextYes;
                        case cafm.enums.DefaultableBooleanData.Either:
                            return cafm.res.str.TextEither;
                        case cafm.enums.DefaultableBooleanData.False:
                            return cafm.res.str.TextNo;
                    }

                    break;
                }
            default:
                {
                    return $('.cfControl', control).val();
                }
        }
    },
    removeFilter: function (item, tv, pnl) {

        var parentItem = item.parents('.tvItem:first');
        var fieldName = parentItem.data('key');
        var textFieldName = parentItem.data('textkey');
        var controlType = cafm.enums.ControlType[parentItem.data('controltype')];
        var criteria = pnl.getViewModel();
        var itemValue = item.data('value').value;

        switch (controlType) {

            case cafm.enums.ControlType.MultiDropdown:

                var lcsItems = criteria.get(fieldName).toJSON();
                cafm.util.removeWhere(lcsItems, function (lcs) {
                    return lcs.value == itemValue;
                });
                criteria.set(fieldName, lcsItems);
                break;

            case cafm.enums.ControlType.TriStateCheckbox:

                var triSel = '#{0}Filter .triChk'.format(item.parents('.tvItem:first').data('key'));
                $(triSel).setTriCheckedState(cafm.enums.DefaultableBooleanData.Either);
                break;

            case cafm.enums.ControlType.LocalitySelector:
            case cafm.enums.ControlType.Lookup:
            case cafm.enums.ControlType.TradeFilter:
            case cafm.enums.ControlType.TradePersonFilter:
            case cafm.enums.ControlType.ReasonCodeFilter:

                var criteriaValue = criteria.get(fieldName);
                
                if (isFunc(criteriaValue.toJSON)) {

                    criteriaValue = criteriaValue.toJSON();
                }

                if (isArray(criteriaValue)) {
                                 
                    cafm.util.removeWhere(criteriaValue, function (o) {

                        return o.value == itemValue;
                    });

                    criteria.set(fieldName, criteriaValue);
                }
                else {

                    criteria.set(fieldName, null);
                    criteria.set(textFieldName, null);
                }

                if (controlType == cafm.enums.ControlType.LocalitySelector) {

                    cafm.hi.resetHierarchyToCompany();
                }

                break;

            default:

                criteria.set(fieldName, null);
                if (textFieldName) {
                    criteria.set(textFieldName, null);
                }
                break;
        }

        tv.remove(item);

        pnl.mergeViewModel(criteria);

        cafm.filters.search(pnl);
    },
    newSearch: function (e) {

        var pnl = $('#mainFilterSet');
        var criteria = pnl.getViewModel();
        if (criteria.HasChanged) {
            
            cafm.filters.filterActions.search(cafm.filters.getPanel());
        }
        else {

            criteria.set('HasChanged', true);
            cafm.filters.showFilterPanel(pnl.data('options'));
        }
    },
    criteriaChanged: function (e) {

        var vm;
        if (e.sender.uid) { // check is the view model
            vm = e.sender;
        }
        else if (e.sender.source) {
            vm = e.sender.source;
        }
        else {
            throw Error('View model object not determined');
        }

        if (!vm.SuppressChangedEvent) {

            vm.set('HasChanged', true);
            if (e.field == 'SearchDescription') {
                vm.set('SearchDescriptionChanged', true);
            }

            if (vm.get('PersistGridState') && e.field == 'VisibleColumns' && !vm.get('SuppressVisibleColumnsChanged')) {
                vm.set('VisibleColumnsChanged', true);
            }

            cafm.filters.fireOnCriteriaChanged(e, vm);
        }
    },
    registerOnFiltersReady: function (f) {

        cafm.handlers.add('cafm.filters.onFiltersReady', f);
    },
    deregisterOnFiltersReady: function () {

        cafm.handlers.remove('cafm.filters.onFiltersReady');
    },
    fireOnFiltersReady: function (e, vm) {

        cafm.handlers.exe('cafm.filters.onFiltersReady', e, vm);
    },
    registerOnCriteriaChanged: function (f) {

        cafm.handlers.add('cafm.filters.onCriteriaChanged', f);
    },
    deregisterOnCriteriaChanged: function () {

        cafm.handlers.remove('cafm.filters.onCriteriaChanged');
    },
    fireOnCriteriaChanged: function (e, vm) {

        cafm.handlers.exe('cafm.filters.onCriteriaChanged', e, vm);
    },
    registerOnCriteriaReset: function (f) {

        cafm.handlers.add('cafm.filters.onCriteriaReset', f);
    },
    deregisterOnCriteriaReset: function () {

        cafm.handlers.remove('cafm.filters.onCriteriaReset');
    },
    fireOnCriteriaReset: function (vm) {

        cafm.handlers.exe('cafm.filters.onCriteriaReset', vm);
    },
    openSaveWindow: function () {
        
        cafm.views.openActionWindow({
            url: cafm.url.get('task/application/savesearch'),
            winTitle: cafm.res.str.MessageEnterSearchDescription,
            winOptions: {
                width: 400,
                height: 180
            },
            closeOnOverlayClick: true,
            onLoad: function (pnl, win) {

                var vm = cafm.filters.getViewModel().toJSON();
                if (vm.IsNewSearch) vm.SearchDescription = '';
                $('#' + cafm.res.consts.ElementId_PopupForm, pnl).bindViewModel({
                    viewModel: vm
                });
                var tbox = pnl.find('#SearchDescription');
                if (tbox.val()) cafm.util.setCaretPosition(tbox, tbox.val().length);
                else tbox.focus();
            }
        });
    },
    saveToolbar: {

        save: function (e) {
            
            if ($('.searchDescForm').validateElement()) {

                var searchDesc = $('#SearchDescription').textVal();
                if (searchDesc) {
                    var criteria = cafm.filters.getViewModel();
                    criteria.set('SearchDescription', searchDesc);
                    criteria.SaveCustomSearch = true;
                    cafm.filters.filterActions.search(cafm.filters.getPanel(), true);
                    cafm.views.closeActionWindow();
                    $('#sub-header h1').text(searchDesc);
                }
            }

        },
        cancel: function (e) {

            cafm.views.closeActionWindow();
        }
    },
    visibleColumnsChanged: function (pnl, dse, options, criteria) {
        
        if (criteria.get('VisibleColumnsChanged')) {

            if (criteria.get('PersistGridState')) {

                criteria.set('VisibleColumnsChanged', false);
            }
                        
            cafm.filters.hideFilterPanel(pnl);
            cafm.nav.router.refresh();
            return;
        }
    },
    exportResults: function (exportFormat) {
        /// <summary>Export search results for the current search page</summary>
        /// <param name="exportFormat" type="cafm.enums.ExportFormatData">The export format (xlsx, csv etc)</param>

        var filterSetElement = cafm.filters.getPanel(),
            criteria = filterSetElement.getViewModel(),
            dsEl = $('#{0}'.format(filterSetElement.data('options').dsElementId)).getGrid(),
            dsElOptions = dsEl.data('options'),
            visibleColumns = cafm.util.selectValue(criteria.get('VisibleColumns'), 'value', true),
            excludeCols = cafm.util.where(dsElOptions.Columns, function (col) {
                return visibleColumns.indexOf(col.field) < 0;
            });

        // extract exclude column names as a list of strings
        excludeCols = cafm.util.selectValue(excludeCols, 'field');

        // check for server defined exclude columns
        if (cafm.util.hasItem(dsElOptions.ExportOptions.ExcludeColumns)) {

            // merge fixed exclude columns into the user defined exclude columns
            cafm.util.addAll(excludeCols, dsElOptions.ExportOptions.ExcludeColumns);
        }

        // create export request DTO
        var exportReq = {
            Format: isStr(exportFormat) ? cafm.enums.ExportFormatData[exportFormat] : exportFormat,
            Service: dsElOptions.ExportOptions.ServiceType,
            ListMemberName: dsElOptions.ExportOptions.ServiceMethod,
            InputParam: criteria,
            ExcludeColumns: excludeCols
        };

        // execute the export download action
        cafm.actions.execute({
            download: true,
            url: cafm.url.api(cafm.res.consts.ApiPath_ExportExecute),
            values: exportReq
        });
    },
    client: {

        filter: function (args) {
            
            if (cafm.util.hasItem(args.filters)) {

                var res = [];

                args.filters.forEach(function(filter){

                    args.data.forEach(function (dataItem) {

                        var criteriaVal = args.criteria[filter.criteriaFieldName],
                            dataVal = dataItem[filter.dataFieldName];

                        switch (filter.filterType) {

                            case cafm.enums.FilterType.Equals:

                                if (criteriaVal === dataVal) {

                                    res.push(dataItem);
                                }

                                break;

                            case cafm.enums.FilterType.WorkOrderSource:
                                
                                if (criteriaVal == cafm.enums.WorkOrderSource.All || criteriaVal == dataVal) {

                                    res.push(dataItem);
                                }

                                break;
                        }
                    });
                });

                return res;
                
            }
            else {

                return args.data;
            }
        },
        comparers: {
            
            contains: function (criteriaValue, dataValue) {
            
                return criteriaValue && dataValue && dataValue.search(new RegExp(criteriaValue, 'i')) != -1;
            },
            starts: function (criteriaValue, dataValue) {

                var dataValueAsString = dataValue.toString();
                return criteriaValue && dataValueAsString && dataValueAsString.toLocaleLowerCase().startsWith(criteriaValue);
            },
            equals: function (criteriaValue, dataValue) {

                return criteriaValue === dataValue;
            },
            equate: function (dataItem, searchText, fields, filterOp) {

                var match = false;

                $.each(fields, function (i, field) {

                    var value = cafm.util.getReference(field, dataItem),
                        func = cafm.filters.client.comparers[cafm.enums.getEnumKey(cafm.enums.FilterType, filterOp).toLowerCase()];

                    if (isFunc(func)) match = func(searchText, value);

                    if (match) return false;
                });

                return match;
            }
        },
        applyFilters: function (fsElement, dsElement) {

            var dataSource = dsElement.getDataSource();

            if (!dsElement.data('unfilteredData'))
                dsElement.data('unfilteredData', dataSource.data().toJSON());

            var data = dsElement.data('unfilteredData');

            if (!dataSource.options.serverPaging && dataSource.page() != 1) dataSource.page(1);

            if (cafm.util.hasItem(data)) {

                var apply = function (element, value) {

                    var filterElement = element.closest('.cFilter[data-filterfields]');

                    if (!filterElement.length) {

                        filterElement = element;
                    }

                    var fields = filterElement.data('filterfields') ? filterElement.data('filterfields').split(',') : [filterElement.getDataBoundFieldName()],
                        filterOp = filterElement.data('filterop') || cafm.enums.FilterType.Equals;

                    var n;
                    if (filterOp == cafm.enums.FilterType.Equals && !isNaN(value)) value = parseInt(n);
                    else if (isStr(value)) value = value.toLocaleLowerCase();
                    data = cafm.util.where(data, function (datatem) { return cafm.filters.client.comparers.equate(datatem, value, fields, filterOp); });
                }

                // filter dropdowns first, this should reduce the filter set with all or mainly int+equals filtering
                fsElement.getDropdowns().forEach(function (kdl) {

                    var value = kdl.value();
                    if (value) {

                        apply(kdl.element, value);
                    }
                });

                // filter text boxes
                fsElement.getTextboxes().forEach(function (e) {

                    var tbox = $(e),
                        text = tbox.val();

                    if (text && (text = text.trim())) {

                        apply(tbox, text);
                    }
                });

                dataSource.data(data);

                if (!data.length && dsElement.hasClass('cGrd')) {

                    cafm.grids.showEmptyGrid(dsElement.data('options'))
                }
                else {

                    dsElement.show().parent().hideMessage(true);
                }
            }
        },
        setupFilters: function (fsElement, dsElement) {

            $('.cfTextInput').on('keyup.cafm', function () {
                cafm.filters.client.applyFilters(fsElement, dsElement);
            });

            $('select').on('change.cafm', function () {
                cafm.filters.client.applyFilters(fsElement, dsElement);
            });
        },
        setupSingleTextBoxFilter: function (fsElement, dsElement) {

            let tbox = fsElement.find('.cfTextInput:first');
            if (!tbox.attr("autocomplete")) tbox.attr("autocomplete", cafm.guid.newGuid());
            tbox.off('keyup.cafm').on('keyup.cafm', e => {
                let kp = e.keyCode ? e.keyCode : e.charCode;
                if ([16, 20, 9, 17].indexOf(kp) == -1)
                    cafm.filters.client.applyFilters(fsElement, dsElement);
            });
        }
    }
}